import { faSignOutAlt, faSpinner, faSync } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { intercept } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Link, withRouter } from 'react-router-dom';
import Badge from "reactstrap/lib/Badge";
import TenantStore from "src/Stores/Tenant/TenantStore";
import { UserStore } from "src/Stores/User/UserStore";
import { WellsStore } from "src/Stores/Wells/WellsStore";
import { IUser } from '../../../../Interfaces/UserInterface';
import ToolTip from '../../../Tooltip';




@inject('stores')
@observer
class AppNav extends React.Component {
    public props: any;
    public userDetails: IUser = new IUser();
    public usersDisposer: any;
    public UserStore: UserStore;
    private WellsStore: WellsStore;
    private TenantStore: TenantStore;
    
    public state = {
        userDetails: this.userDetails,
    };

    constructor(props: any) {
        super(props);
        this.UserStore = this.props.stores.UserStore;
        this.WellsStore = this.props.stores.WellsStore;
        this.TenantStore = this.props.stores.TenantStore;
        this.profileLinkDisplay = this.profileLinkDisplay.bind(this);
    }

    public componentDidMount() {
        this.createDisposers();
    }

    private createDisposers() {
        this.usersDisposer = intercept(this.UserStore, 'user', (change: any) => {
            const userDetails: IUser = change.newValue;

            this.setState({
                userDetails
            });
            return change;
        });
    }

    public userMenu() {
        return(
            <ul>
                <li>Logout</li>
            </ul>
        );
    }

    public componentWillUnmount() {
        this.usersDisposer();
    }

    private profileLinkDisplay() {
        const userName = this.state.userDetails.email;
        return (userName) ? 'Profile for ' + userName : 'Profile';
    }

    private logoutUser = () => {
        this.props.history.push('/');
        if (this.props.history.location.pathname === '/') {
            localStorage.removeItem('id_token');
            localStorage.removeItem('online_token');
            localStorage.removeItem('userName');
            this.UserStore.clearUser();
        }
    }

    private canViewTests() {
        return (this.props.match.params.wellId &&
            this.props.match.params.wellId !== 'new' &&
            this.props.match.params.wellId !== null
            && this.WellsStore.well
            && this.WellsStore.well.wellStatus === 'Active'
            && this.UserStore.hasGenericPermission("Permissions.WellTests.Read"));
    }

    public render() {
        return(
        <div className="AppNav">
            { !this.props.expanded &&
            <h6>
            { this.props.stores.SyncStore.offline ? 
                <Badge color="warning" >Offline</Badge> :
                this.props.stores.syncingOffline ? 
                <Badge color="success">
                    <FontAwesomeIcon
                        icon={faSpinner}
                        spin={true}
                    />
                </Badge>
                :
                <Badge color="success">Online</Badge>
            }
            </h6>
            }
            { !this.props.expanded &&
                <ul className="AppNav-workflow-options">
                    <li onClick={this.props.stores.getAllDataForOffline}>
                        <ToolTip text="Refresh Offline Data" position="right">
                            <FontAwesomeIcon
                                icon={faSync}
                                size="2x"
                                color={this.TenantStore.onBrandIconColor}
                            />
                        </ToolTip>
                    </li>
                    <li>
                        {
                            this.UserStore.hasGenericPermission("Permissions.Wells.Read") &&
                        <Link to="/home">
                            <ToolTip text="Well List" position="right">
                                <FontAwesomeIcon icon="list-ul" color={this.TenantStore.onBrandIconColor} size="2x"/>
                            </ToolTip>
                        </Link>
                        }
                    </li>
                    {this.canViewTests() &&
                        <li>
                            <Link to={ "/well/" + this.props.match.params.wellId + "/test/new/welldata/testsetup" }>
                                <ToolTip text="Add New Test" position="right">
                                    <FontAwesomeIcon
                                        icon="plus"
                                        color={this.TenantStore.onBrandIconColor}
                                        size={"2x"}
                                    />
                                </ToolTip>
                            </Link>
                        </li>
                    }
                    <li>
                        { this.UserStore.hasPermission('Permissions.Admin.View') && 
                        <Link to={ '/admin'}>
                            <ToolTip text="Admin" position="right">
                                <FontAwesomeIcon icon="user-cog" color={this.TenantStore.onBrandIconColor} size="2x"/>
                            </ToolTip>
                        </Link> }
                    </li>
                </ul>
            }
            <div className="AppNav-options">
                <div className="icon-wrapper">
                    <ToolTip text={this.profileLinkDisplay()} position="right">
                        <Link to="/profile"><FontAwesomeIcon icon={['far', 'user-circle']} color={this.TenantStore.onBrandIconColor} size="2x"/></Link>
                    </ToolTip>
                </div>
                <div className="icon-wrapper">
                    <ToolTip text="Logout" position="right">
                        <div onClick={this.logoutUser} style={{cursor: 'pointer'}}><FontAwesomeIcon icon={faSignOutAlt} color={this.TenantStore.onBrandIconColor} size="2x" /></div>
                    </ToolTip>
                </div>
                {/* 
                Removed MUD 3180
                <div className="icon-wrapper">
                    <ToolTip text="Notifications" position="right">
                        <FontAwesomeIcon icon={['far', 'bell']} color={this.TenantStore.onBrandIconColor} size="2x"/>
                    </ToolTip>
                </div> 
                */}
                <div className="icon-wrapper">
                    <ToolTip text="Help" position="right">
                        <Link to="/print/help/engineermanual" target="_blank">
                            <FontAwesomeIcon icon={['far', 'question-circle']} color={this.TenantStore.onBrandIconColor} size="2x"/>
                        </Link>
                    </ToolTip>
                </div>
            </div>
        </div>
        );
    }
}

export default withRouter(AppNav);



// WEBPACK FOOTER //
// ./src/Components/Main/Sidebar/AppNav/AppNav.tsx